import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';

import { ContextProvider } from './Context';
import Header from './Views/Header/Index';
import List from './Views/List/Index';

export default function Index({ enterpriseId }) {
  return (
    <StrictMode>
      <ContextProvider enterpriseId={enterpriseId}>
        <div className="content">
          <Header />
          <List />
        </div>
      </ContextProvider>
    </StrictMode>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
};
